import { Component, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { SwiperComponent } from '../../../common/components';
import { NodeModel } from '../../../common/models';

@Component({
    selector: 'lib-challenges-widget',
    templateUrl: './challenges-widget.component.html',
    styleUrls: ['./challenges-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChallengesWidgetComponent {
  @Input() public challenges: NodeModel[] = [];
  @Input() public textColor: string;

  @ViewChild(SwiperComponent) swiperComponent: SwiperComponent;

  @Output() public navigateToChallenge: EventEmitter<NodeModel> = new EventEmitter();
  @Output() public joinChallenge: EventEmitter<NodeModel> = new EventEmitter();

  public carouselConfig = {
    breakpoints: {
      0: {
        reducedWidth: true,
        showOverflow: true
      },
      480: {
        reducedWidth: false,
        showOverflow: false
      }
    }
  }
}
